export const vibrant = {
  100: "#D49AE8",
  200: "#BE88D1",
  300: "#A876BA",
  400: "#9263A3",
  500: "#7C518D",
  600: "#663F76",
  700: "#522E61",
  800: "#3B1B4A",
  900: "#260933",
};

export const neutral = {
  100: "#D9C4E1",
  200: "#C2AEC9",
  300: "#AA97B1",
  400: "#928199",
  500: "#7B6A82",
  600: "#65566C",
  700: "#4E3F54",
  800: "#36283C",
  900: "#1E1224",
  white: "#FFFFFF",
};
